import React, { Component } from "react";

export default class RoomRugFilterBrands extends Component {
  handleManualScroll = (direction) => {
    switch (direction) {
      case "right":
        document.getElementById("ulSlider").scrollLeft -= 120;
        break;
      default:
        document.getElementById("ulSlider").scrollLeft += 120;
        break;
    }
  };

  render() {
    return (
      <>
        <button
          name="scroll-right"
          className="m-0 button-shadow-right"
          onClick={() => {
            this.handleManualScroll("right");
          }}
        >
          <svg
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            viewBox="0 0 240.823 240.823"
            enableBackground="new 0 0 240.823 240.823"
          >
            <g>
              <path
                id="Chevron_Right_1_"
                d="M183.189,111.816L74.892,3.555c-4.752-4.74-12.451-4.74-17.215,0c-4.752,4.74-4.752,12.439,0,17.179
                                        l99.707,99.671l-99.695,99.671c-4.752,4.74-4.752,12.439,0,17.191c4.752,4.74,12.463,4.74,17.215,0l108.297-108.261
                                        C187.881,124.315,187.881,116.495,183.189,111.816z"
              />
            </g>
          </svg>
        </button>
        <ul id="ulSlider">

          {this.props.brands.map((brand) => (
            <li
              className={
                this.props.selectedBrands.indexOf(brand.id) >= 0 ? "active" : ""
              }
              key={"filterBrand" + brand.id + brand.name}
              onClick={() =>
                this.props.selectHandler(brand.id, this.props.activeFilter)
              }
            >
              {brand.name}
            </li>
          ))}

          {this.props.loading && <li>در حال دریافت اطلاعات ...</li>}

        </ul>
        <button
          name="scroll-left"
          className="m-0 button-shadow-left"
          onClick={() => {
            this.handleManualScroll("left");
          }}
        >
          <svg
            version="1.1"
            x="0px"
            y="0px"
            viewBox="0 0 240.823 240.823"
            enableBackground="new 0 0 240.823 240.823"
          >
            <g>
              <path
                id="Chevron_Right"
                d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z"
              />
            </g>
          </svg>
        </button>
      </>
    );
  }
}
